<div class="emds" id="{{Id}}">
  <div class="modal-default">
    <div class="modal-header">
      <span>{{message?.Header}}</span>
      <div id="fnd-advanceddirectivemodal-close-x"
           class="emds-close"
           (click)="close(false)">&times;</div>
    </div>
    <div class="modal-body">
      <fp-message-reply [baseId]="baseId"
                  [readOnly]="readOnly"
                  [messageId]="message.MessageId"
                  [alertWarnings]="alertWarnings"
                  (dataSaved)="close($event)">
      </fp-message-reply>
    </div>
    <div class="modal-footer">
    </div>
  </div>
</div>
